import * as actions from './expenseJournal/actions'
import * as mutations from './expenseJournal/mutations'
import * as getters from './expenseJournal/getters'

import { dataProps } from './expenseJournal/properties'

const state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.journal_date',
        sort_direction: 1, search_term: '', 
search_term_array: []
    },
    props: JSON.parse(JSON.stringify(dataProps)),
    export_expense: [],
    location_id: null
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/expenseJournal.js